<template>
	<!-- <div class="foot_menu">
		<div v-show="$route.name == 'home' " class="foot_link" @click="$router.push({name:'home'})"><img class="foot_img" src="static/icon/list_act.png"><div class="foot_font active">站点排名</div></div>
    <div v-show="$route.name != 'home' " class="foot_link" @click="$router.push({name:'home'})"><img class="foot_img" src="static/icon/list.png"><div class="foot_font">站点排名</div></div>

    <div v-show="$route.name == 'chart'" class="foot_link" @click="$router.push({name:'chart'})"><img class="foot_img" src="static/icon/chart_act.png"><div class="foot_font active">扬尘云图</div></div>
    <div v-show="$route.name != 'chart'" class="foot_link" @click="$router.push({name:'chart'})"><img class="foot_img" src="static/icon/chart.png"><div class="foot_font">扬尘云图</div></div>

    <div v-show="$route.name == 'set'" class="foot_link" @click="$router.push({name:'set'})"><img class="foot_img" src="static/icon/set_act.png"><div class="foot_font active">我</div></div>
    <div v-show="$route.name != 'set'" class="foot_link" @click="$router.push({name:'set'})"><img class="foot_img" src="static/icon/set.png"><div class="foot_font">我</div></div>
  </div> -->
  
</template>
<script>
  export default {
    name: 'HelloWorld',
    data () {
      return {
        active:0
      }
    }
  }
</script>
<style scoped>
.foot_menu{
  height: 51px;
  position: fixed;
  width: 100%;
  bottom: 0px;
  padding-top: 4px;
  background: #f6f6f6
}
.foot_link{
  width: 31%;
  display: inline-block;
  text-align: center;
  padding-left: 4px
}
.foot_img{
  position: relative;
}
.foot_font.active{
  color: #1195db;
  font-size: 13px
}
.foot_font{
  display: block;
  font-size: 11px;
  color: #949494;
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/components/commons/foot.vue